<template>
  <div class="bg-white card relative overflow-hidden flex flex-col card-skeleton">
    <div class="flex align-center justify-between flex-end">
      <span class="mt-4 ml-4 text-skeleton opacity-low-half rounded inline-block font-display-02 mb-3">
        VIEW
      </span>
      <SmartButton
        class="button-skeleton opacity-low-half mr-4"
        secondary>
        Good Button
      </SmartButton>
    </div>
    <div class="flex align-center space mb-4 card-skeleton__footer">
      <div class="mt-auto">
        <p class="text-skeleton opacity-low-half rounded inline-block ml-4 mb-2">
          Status atual
        </p>
        <br />
        <p class="ml-4 text-skeleton opacity-low-half rounded inline-block">
          Meta aprovada
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// @flow
export default {
  name: 'SmartCardViewSkeleton'
};
</script>

<style scoped lang="scss">

.text-skeleton, .button-skeleton, .background-skeleton {
  color: transparent;
  background: $color-ui-gray;
}

.card {
  max-width: 480px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  min-height: 210px;
  &__icon {
    right: - $spacing-margin-xxsmall;
    bottom: - $spacing-margin-xxsmall;
  }
}

.card-skeleton {
  &__footer {
    flex: 10;
  }
  &__icon {
    z-index: 0;
  }
}
</style>
